<template>
  <div>
    <q-dialog
      :visible="isVisible"
      title="转账"
      width="600px"
      :innerScroll="false"
      @close="onCancel"
      @cancel="onCancel"
      @confirm="onConfirm"
    >
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
        <el-form-item label="出账经销商编码" size="small" prop="outCusCode">
          <el-input 
            placeholder="请输入" 
            oninput="this.value=this.value.replace(/[\u4e00-\u9fa5]/g,'')" 
            v-model="ruleForm.outCusCode"
            @blur="blurGetCusName('out')"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="出账经销商名称" size="small" prop="outCusCodeName">
          <el-input placeholder="根据编码自动获取" v-model="ruleForm.outCusCodeName" disabled></el-input>
        </el-form-item>
        <el-form-item label="出账经销商余额" size="small" prop="balance">
          <el-input  placeholder="根据编码自动获取" v-model="ruleForm.balance" disabled></el-input>
        </el-form-item>
        <el-form-item  label="入账经销商编码" size="small" prop="inCusCode">
          <el-input 
            placeholder="请输入" 
            oninput="this.value=this.value.replace(/[\u4e00-\u9fa5]/g,'')" 
            v-model="ruleForm.inCusCode"
            @blur="blurGetCusName('in')"
          >
          </el-input>
        </el-form-item>
    
        <el-form-item label="入账经销商名称" size="small" prop="inCusCodeName">
          <el-input placeholder="根据编码自动获取" v-model="ruleForm.inCusCodeName" disabled></el-input>
        </el-form-item>
        <el-form-item  label="转账金额" size="small" prop="amount">
          <el-input type="number" placeholder="只能小于等于出账钱包余额" v-model="ruleForm.amount" @blur="formatField"></el-input>
        </el-form-item>
        <el-form-item label="申请人" size="small" prop="applyPerson">
          <el-input placeholder="请输入" v-model="ruleForm.applyPerson"></el-input>
        </el-form-item>
      </el-form>
    </q-dialog>
  </div>
</template>

<script>
import { formatNumber } from '@/utils'
export default {
  props: {
    isTransferPop: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      ruleForm: {
        amount: '',
        applyPerson: '',
        inCusCode: '',
        inCusCodeName: '',
        balance: '',
        outCusCode: '',
        outCusCodeName: '',
      },
      rules: {
        outCusCode: [
          { required: true, message: '请输入出账经销商编码', trigger: 'blur' },
          { min: 0, max: 255, message: '长度不能超过255个字符', trigger: 'blur' }
        ],
        outCusCodeName: [
          { required: true, message: '请输入出账经销商名称', trigger: 'blur' },
        ],
        balance: [
          { required: true, message: '请输入出账经销商余额', trigger: 'blur' },
        ],
        inCusCode: [
          { required: true, message: '请输入入账经销商编码', trigger: 'blur' },
          { min: 0, max: 255, message: '长度不能超过255个字符', trigger: 'blur' }
        ],
        inCusCodeName: [
          { required: true, message: '请输入入账经销商名称', trigger: 'blur' },
        ],
        amount: [
          { required: true, message: '请输入转账金额', trigger: 'blur' },
          { min: 0, max: 255, message: '长度不能超过255个字符', trigger: 'blur' }
        ],
        applyPerson: [
          { required: true, message: '请输入申请人', trigger: 'blur' },
          { min: 0, max: 255, message: '长度不能超过255个字符', trigger: 'blur' }
        ],
      },
      isClike: true
    }
  },
  computed: {
    isVisible: {
      get() {
        return this.isTransferPop
      },
      set(newVal) {
        this.$emit('update:isTransferPop',newVal)
      }
    }
  },
  methods: {
    onCancel() {
      this.isVisible = false
      this.$refs.ruleForm.resetFields()
    },
    onConfirm() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const { amount,balance } = this.ruleForm
          if (amount > balance) {
            this.$message.warning('转账金额不能大于出账经销商余额');
            return
          }
          if (this.isClike) {
          
            this.isClike = false
            this.$api.dataReport.transfer(this.ruleForm)
              .then(res => {
                this.$message.success('转账成功')
                this.onCancel()
                this.$emit('transferSuccess')
              }).finally(_=> {
                  setTimeout(() => {
                    this.isClike = true
                  },500)
              })
          }
        }
      })
    },
    blurGetCusName(type) {
      const { outCusCode,inCusCode } = this.ruleForm
       let code = type == 'out' ? outCusCode : inCusCode
      if (code) {
        this.$api.dataReport.getCusInfo(code)
          .then(res => {
            if (res.data) {
              // 出账名称
              if (type == 'out') {
                this.ruleForm.outCusCodeName = res.data.cusName
                this.ruleForm.balance = res.data.cusSurplus
              }else {
                this.ruleForm.inCusCodeName = res.data.cusName
              }
            }else {
              this.$message.warning(`${type == 'out' ? '出账' : '入账'}经销商编码不存在，请重新输入`);
            }
          })
      }
    },
    formatField() {
      let amount = this.ruleForm.amount.replace(/-/g,'')
      this.ruleForm.amount = Number(amount).toFixed(2)
    }
  }
}
</script>

<style>

</style>